/* One repeat engine, now hosted by the main product image's dialog. */
if (!customElements.get('swatch-repeat')) {
  customElements.define('swatch-repeat', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.field = this.querySelector('.swatch-repeat__field');
      this.range = this.querySelector('input[type="range"]');
      this.edges = this.querySelector('input[type="checkbox"]');
      this.output = this.querySelector('output');
      this.range.addEventListener('input', () => this.schedule(), {signal});
      this.edges.addEventListener('change', () => this.update(), {signal});
      window.addEventListener('resize', () => this.schedule(), {signal});
      this.resizeObserver = new ResizeObserver(() => this.schedule());
      this.resizeObserver.observe(this.field);
      this.bindSource();
    }
    setSource(image) {
      if (this.source === image && this.sourceController) return;
      this.source = image;
      this.bindSource();
    }
    bindSource() {
      this.sourceController?.abort();
      if (!this.source || !this.controller) return;
      this.sourceController = new AbortController();
      const {signal} = this.sourceController;
      const ready = () => {
        if (!this.source.naturalWidth || !this.source.naturalHeight) return;
        // Never reuse or replace the protected main image. Pixify's clean
        // thumbnail is supplied explicitly for this viewer only.
        const width = Number(this.dataset.tileWidth);
        const height = Number(this.dataset.tileHeight);
        if (!this.dataset.tileSrc || !(width > 0 && height > 0)) return;
        this.ratio = height / width;
        this.field.style.backgroundImage = 'url(' + JSON.stringify(this.dataset.tileSrc) + ')';
        this.update();
      };
      this.source.addEventListener('load', ready, {signal});
      this.source.addEventListener('error', () => { this.field.style.backgroundImage = ''; }, {signal});
      if (this.source.complete) ready();
    }
    reset() {
      this.range.value = '60';
      this.edges.checked = false;
      this.update();
    }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
    }
    update() {
      if (!this.field) return;
      const scale = Math.max(40, Math.min(100, Number(this.range.value) || 60));
      this.range.value = String(scale);
      // 40% is exactly four columns; higher values enlarge the same proportional tile.
      // Keep fractional CSS pixels so four tiles fit even on odd-width screens.
      const fieldWidth = this.field.getBoundingClientRect().width || window.innerWidth;
      const width = fieldWidth / 4 * scale / 40;
      this.field.style.setProperty('--tile-width', width + 'px');
      this.field.style.setProperty('--tile-height', width * (this.ratio || 1) + 'px');
      this.output.value = scale + '%';
      this.range.setAttribute('aria-valuetext', scale + '%');
      this.toggleAttribute('data-edges', this.edges.checked);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.resizeObserver?.disconnect();
      this.frame = null;
      this.sourceController?.abort();
      this.sourceController = null;
      this.controller?.abort();
      this.controller = null;
    }
  });
}
